import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      {/* Top section */}
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-14 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand info */}
          <div>
            <Link to="/" className="font-heading text-2xl font-bold whitespace-nowrap">
              韩国漫画网
            </Link>
            <p className="mt-4 text-foreground-400 text-sm leading-relaxed">
              免费韩漫大全，每日更新好看的韩国漫画。<br />
              支持韩漫在线观看，高清流畅阅读。
            </p>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-foreground-400 text-xs uppercase tracking-widest font-medium mb-4">
              订阅更新
            </h4>
            <form
              action="#"
              method="POST"
             
              className="relative"
            >
              <input
                type="email"
                name="email"
                placeholder="输入邮箱订阅新作通知"
                className="w-full bg-transparent border-0 border-b border-foreground-700 py-2 text-sm text-background-50 placeholder:text-foreground-500 focus:outline-none focus:border-accent-500 transition-colors"
              />
              <button
                type="submit"
                className="absolute right-0 top-1/2 -translate-y-1/2 w-8 h-8 flex items-center justify-center rounded-full bg-accent-500 text-foreground-950 cursor-pointer hover:bg-accent-400 transition-colors"
                aria-label="订阅"
              >
                <i className="ri-arrow-right-line text-sm"></i>
              </button>
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly={true}
              />
            </form>
            <p className="mt-2 text-xs text-foreground-500">
              订阅即表示同意我们的
              <Link to="/about" className="text-accent-500 underline mx-1 whitespace-nowrap">隐私政策</Link>
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-foreground-400 text-xs uppercase tracking-widest font-medium mb-4">
              分类导航
            </h4>
            <ul className="flex flex-col gap-2">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-accent-500 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Social & links */}
          <div>
            <h4 className="text-foreground-400 text-xs uppercase tracking-widest font-medium mb-4">
              关于我们
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-accent-500 transition-colors whitespace-nowrap">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-accent-500 transition-colors whitespace-nowrap">
                  联系我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-accent-500 transition-colors whitespace-nowrap">
                  用户协议
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-accent-500 transition-colors whitespace-nowrap">
                  隐私政策
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Brand strip */}
      <div className="w-full py-8 md:py-12 flex items-center justify-center overflow-hidden select-none">
        <span
          className="font-heading font-black text-[12vw] md:text-[10vw] leading-none tracking-tighter whitespace-nowrap text-foreground-800/20"
          aria-hidden="true"
        >
          韩国漫画网
        </span>
      </div>

      {/* Copyright */}
      <div className="border-t border-foreground-800/50">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-foreground-500">
            &copy; 2026 韩国漫画网. 保留所有权利.
          </p>
          <p className="text-xs text-foreground-500">
            本站所有漫画资源仅供学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}